import React, {useEffect} from 'react';
import DefaultButton from '@core/buttons/electrons/DefaultButton';
import {useScrollLock} from '@hooks/useScrollLock';
import {amountFormatter} from "@utils/helpers";
import {HiMinus, HiPlus} from "react-icons/hi";

const ProductPreview = ({
                          product,
                          selectedQty,
                          onProductAdd,
                          onProductRemove,
                          isOpen,
                          setIsOpen,
                          onClose,
                          viewMode
                        }) => {
  const {id, name, description, imagePath, price} = product;
  const {unlockScroll, lockScroll} = useScrollLock();

  const close = (event) => {
    event.stopPropagation();
    setIsOpen(false);
    if (onClose) onClose();
  };

  useEffect(() => {
    isOpen ? lockScroll() : unlockScroll();
  }, [isOpen, lockScroll, unlockScroll]);


  return (
    <main
      className={`fixed overflow-hidden z-30 bg-gray-900 bg-opacity-25 inset-0 mx-auto ${
        isOpen
          ? 'transition-opacity opacity-100 duration-500'
          : 'transition-opacity opacity-0 delay-500 translate-x-full'
      }`}
      data-testid="product-preview"
    >
      <div className="flex justify-center"
      >
        <section
          style={{maxWidth: 600}}
          className={`w-full bottom-0 absolute bg-white shadow-xl delay-400 duration-500 ease-in-out transition-all transform rounded-t-3xl ${
            isOpen ? 'translate-y-0' : 'translate-y-full'
          }`}
        >
          <article className="relative w-full flex flex-col space-y-6 justify-between p-6">
            <div className="w-full rounded-md">
              <img
                src={imagePath}
                alt={name}
                className="w-full h-auto object-contain cursor-pointer rounded-md"
                onClick={() => setIsOpen(!isOpen)}
              />
            </div>

            <div className='flex flex-col w-full align-start'>
              <div className="flex-1">
                <div className="text-base font-[600]">{name}</div>
                <div className="text-sm my-0.5">{description}</div>
              </div>
              <div className="flex items-center justify-between">
                <div className="text-gray-900 font-[600] mt-5 text-lg">{amountFormatter(price, 'ALL')}</div>
                {!viewMode && <div className='flex'>
                  <div
                    onClick={() => onProductRemove(id)}
                    className="p-1 bg-gray-200 text-gray-900 rounded-full mx-3 active:opacity-70 active:text-opacity-70 cursor-pointer transition duration-300"
                  >
                    <HiMinus size={16}/>
                  </div>
                  <div className="text font-semibold">{selectedQty}</div>
                  <div
                    onClick={() => onProductAdd(product)}
                    className="p-1 bg-gray-200 text-gray-900 rounded-full mx-3 active:opacity-70 active:text-opacity-70 cursor-pointer"
                  >
                    <HiPlus size={16}/>
                  </div>
                </div>}
              </div>
            </div>
            <div className="flex flex-row-reverse bottom-5">
              <DefaultButton textColor='text-white'
                             label='Close' onClick={close} rounded='rounded-2xl'/>
            </div>
          </article>
        </section>
      </div>
      <section className="w-full h-full cursor-pointer" onClick={close}/>
    </main>
  );
};

export default ProductPreview;